import OfficesCard from './offices-card';

export default class OfficesCardDesktop extends OfficesCard {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/offices-card/offices-card.desktop.js